module.exports = __webpack_public_path__ + "img/co_wrapbg3.64aabaff.png";